/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

import {FileService} from './file.service';
import {ImageCropperComponent} from './image-cropper.component';
import {ImagePickerComponent} from './image-picker.component';
import {UploadFileComponent} from './upload-file/upload-file.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [ImagePickerComponent, ImageCropperComponent, UploadFileComponent],
  exports: [ImagePickerComponent, ImageCropperComponent, UploadFileComponent],
  providers: [FileService]
})
export class FilesModule {
}
